import parse from 'html-react-parser';

import { Field, Text } from '@sitecore-jss/sitecore-jss-nextjs';

import { formatDate } from 'src/mappers/fields/parseDate';

import overviewStyles from '../../CourseDetailOverview.module.css';

type contentDetailsMainProps = {
	Information: string | null | undefined;
	CertificateOfCompletion: boolean | undefined;
	CertificateOfCompletionText?: Field<string>;
	YesCertificateText?: Field<string>;
	NoCertificateText?: Field<string>;
	DateReviewed?: Date | null | undefined;
	DateReviewedText?: Field<string>;
	DateReviewedTextPlaceholder?: Field<string>;
	DatePublished?: Date | null | undefined;
	DatePublishedText?: Field<string>;
	DatePublishedTextPlaceholder?: Field<string>;
	DateUpdated?: Date | null | undefined;
	DateUpdatedText?: Field<string>;
	DateUpdatedTextPlaceholder?: Field<string>;
	ProfessionalLeads:
		| {
				Text?: string | undefined;
				FirstName?: string | undefined;
				LastName?: string | undefined;
				Email?: string | undefined;
		  }
		| undefined;
	AuthorsText?: Field<string>;
	ProfessionalLeadsText?: Field<string>;
	ProfessionalLeadsTextPlaceholder?: Field<string>;
	ResourceSponsor: string | undefined;
	ResourceSponsorText?: Field<string>;
	HasAccess: boolean | undefined;
	QualityAssuranceText: Field<string>;
};

export function ContentDetailsMain(props: contentDetailsMainProps) {
	const datePublished = formatDate(props.DatePublished);
	const dateUpdated = formatDate(props.DateUpdated);
	const dateReviewed = formatDate(props.DateReviewed);

	return (
		<>
			{props.Information && <div className={overviewStyles.detail}>{parse(props.Information?.toString() ?? '')}</div>}

			{props.CertificateOfCompletion && (
				<div className={overviewStyles.detail}>
					<Text tag="h3" field={props.CertificateOfCompletionText} />

					{props.CertificateOfCompletion ? (
						<Text tag="p" field={props.YesCertificateText} />
					) : (
						<Text tag="p" field={props.NoCertificateText} />
					)}
				</div>
			)}

			{props.DatePublished && (
				<div className={overviewStyles.detail}>
					<Text tag="h3" field={props.DatePublishedText} />
					<p>{datePublished ? datePublished : <Text field={props.DatePublishedTextPlaceholder} />}</p>
				</div>
			)}

			{props.DateReviewed && (
				<div className={overviewStyles.detail}>
					<Text tag="h3" field={props.DateReviewedText} />
					<p>{dateReviewed ? dateReviewed : <Text field={props.DateReviewedTextPlaceholder} />}</p>
				</div>
			)}

			{props.DateUpdated && (
				<div className={overviewStyles.detail}>
					<Text tag="h3" field={props.DateUpdatedText} />

					<p>{dateUpdated ? dateUpdated : <Text field={props.DateUpdatedTextPlaceholder} />}</p>
				</div>
			)}

			{props.ProfessionalLeads && (
				<div className={overviewStyles.detail}>
					<Text tag="h3" field={props.ProfessionalLeadsText || props.AuthorsText} />

					<div>
						{!props.ProfessionalLeads || (!props.ProfessionalLeads.FirstName && !props.ProfessionalLeads.Text) ? (
							<Text field={props.ProfessionalLeadsTextPlaceholder} />
						) : props.ProfessionalLeads.FirstName ? (
							<a href={`mailto:${props.ProfessionalLeads.Email}`}>
								{props.ProfessionalLeads.FirstName ?? ''} {props.ProfessionalLeads.LastName ?? ''}
							</a>
						) : props.ProfessionalLeads.Text ? (
							parse(props.ProfessionalLeads.Text.toString())
						) : (
							''
						)}
					</div>
				</div>
			)}

			{props.ResourceSponsor && (
				<div className={overviewStyles.detail}>
					<Text tag="h3" field={props.ResourceSponsorText} />

					<div>{props.ResourceSponsor}</div>
				</div>
			)}

			{!props.HasAccess && <Text tag="small" field={props.QualityAssuranceText} />}
		</>
	);
}
